import "./intelligent-home/intelligenthome.js";
import "../personalization-component/micro-survey/microsurvey.js";
import "./intelligent-home/intelligenthome.css";
import "./hero-section/herosection.css";
// Enterprise Links
import "./enterprise-links/enterpriselinks.css";

document.querySelectorAll('.ih-product-card__image').forEach(function (ele) {
    ele.onerror = function () {
        this.setAttribute("style", "width:55%;max-height:300px;")
        this.src = '//i.dell.com/is/image/DellContent/content/dam/ss2/non-product-images/icons/no_product_image.svg';
        this.onerror = null;
    };
});

const dellMetricsTrackProp20 = (appcode, tabname) => {
    try {
        if (typeof (window.dellmetricsTrack) === "function") {
            if (window.dellmetricsTrack) {
                window.dellmetricsTrack(appcode, tabname);
            }
        }
    } catch (ex) {
        console.error(`${ex}`);
    }
}

// product info section
const SetInnerHtml = (elm, html) => {
    elm.innerHTML = html;
    Array.from(elm.querySelectorAll("script")).forEach((oldScript) => {
        const newScript = document.createElement("script");

        Array.from(oldScript.attributes)
            .forEach((attr) => newScript.setAttribute(attr.name, attr.value));
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
    });
}

async function getAssetId(url) {
    const response = await fetch(url,
        {
            credentials: 'include'
        });
    if (response.status === 200) {
        const json = await response.text();
        return json;
    }
}

const reviewServicesButton = document.getElementById("manageServices");
const findDriversButton = document.getElementById("finddrivers");
if (reviewServicesButton) {
    const serviceTag = reviewServicesButton.dataset.servicetag;
    const appName = reviewServicesButton.dataset.appname;
    const language = Dell.Metrics.sc.language;
    const country = Dell.Metrics.sc.country;

    var hostname = "";
    if (window.location.hostname.indexOf("localhost") === 0) {
        hostname = "https://www-sit-g2.dell.com";
    }
    const encValueUrl = `${hostname}/support/components/detectproduct/encvalue`;
    const supportServicesBaseUrl = `${hostname}/support/contractservices/${language}-${country}/entitlement/contractservicesapi/v1`;
    const warrantyModalUrl = `${hostname}/support/contractservices/${language}-${country}/warrantydetailsinit?appName=${appName}`;
    const encryptedTagUrl = `${encValueUrl}/${serviceTag}?appname=warranty`;

    getAssetId(encryptedTagUrl)
        .then((response) => {
            const supportServiceApiUrl = `${supportServicesBaseUrl}`;
            const assetId = response;

            fetch(supportServiceApiUrl,
                {
                    "method": "POST",
                    "body": JSON.stringify({
                        "assetFormat": "servicetag",
                        "assetId": assetId,
                        "appName": "home"
                    }),
                    "headers": {
                        "Content-Type": "application/json"
                    },
                    "credentials": "include"
                })
                .then((res) => res.json())
                .then((data) => {
                    const warrantyEndDate = data.warrantyEndDate;
                    const subscriptionEnabled = data.isSubscriptionEnabled;
                    const warrantyDisplayName = data.warrantyDisplayName;
                    const extendUpgrade = data.renewOrManageSubscriptionLink;
                    const isUnRegisteredRetailAsset = data?.retailAssetInfo?.isUnRegisteredRetailAsset;
                    const isRetailRegistrationPending = data?.retailAssetInfo?.isRetailRegistrationPending;
                    const renewOrManageSubscriptionLink = data?.renewOrManageSubscriptionLink;
                    const isIssueWithAsset = data.isIssueWithAsset;
                    const daysRemaining = data.daysRemaining;
                    const isEOSLReached = data.isEOSLReached;
                    const isHesAsset = data.isHesAsset;
                    const isSingleSerializedAsset = data.isSingleSerializedAsset;
                    const assetFormatVal = "servicetag";
                    var warratyDetailsText = `<div class="dds__row dds__flex-md-column dds__flex-column dds__flex-lg-row dds__justify-content-center dds__justify-content-lg-start">
                                                <div class="dds__d-flex dds__justify-content-center dds__justify-content-lg-start">`;

                    if (data.warrantyIconSvg !== null) {
                        warratyDetailsText += `<i class="dds__icon dds__icon--${data.warrantyIconSvg} dds__mr-2 dds__mt-1" style="color:var(--${data.warrantyIconCss})"></i>`;
                    }

                    if (data.issueWithSupportServicesText !== null) {
                        warratyDetailsText += data.issueWithSupportServicesText;
                    }
                    else if (data.warrantyDisplayName !== null && data.warrantyDisplayName !== '') {
                        warratyDetailsText += data.warrantyDisplayName;
                    }

                    warratyDetailsText += `</div><div class="dds__d-flex dds__justify-content-center dds__justify-content-lg-start">`;
                    var warrantyDotLabel = `<span class="mr-0 d-none d-lg-inline text-dark dds__px-2 dds__d-none dds__d-lg-block">|</span>`;

                    if (data.issueWithSupportServicesText !== null) {
                        warratyDetailsText += "";
                    }
                    else if (data.warrantyDisplayName !== null && data.warrantyStatusText !== null && data.warrantyEndDate !== null && data.retailAssetInfo !== null && data.retailAssetInfo.retailRegisterMessageText === null && data.retailAssetInfo.retailRegisterPendingText === null) {
                        warratyDetailsText += warrantyDotLabel + "<span>" + data.warrantyStatusText + " " + data.warrantyEndDate + "</span>";
                    }
                    else if (data.retailAssetInfo.retailRegisterMessageText !== null) {
                        warratyDetailsText += warrantyDotLabel + "<span>" + data.warrantyStatusText + " " + data.warrantyEndDate + `</span></div><div class="dds__d-flex dds__justify-content-center dds__justify-content-lg-start">` + warrantyDotLabel + "<span>" + data.retailAssetInfo.retailRegisterMessageText + "</span>";
                    }
                    else if (data.retailAssetInfo.retailRegisterPendingText !== null) {
                        warratyDetailsText += warrantyDotLabel + "<span>" + data.warrantyStatusText + " " + data.warrantyEndDate + `</span></div><div class="dds__d-flex dds__justify-content-center dds__justify-content-lg-start">` + warrantyDotLabel + "<span>" + data.retailAssetInfo.retailRegisterPendingText + "</span>";
                    }

                    warratyDetailsText += `</div></div><div class="dds__row dds__flex-column dds__flex-md-column dds__flex-lg-row dds__justify-content-md-center dds__justify-content-lg-start dds__pl-lg-4 dds__pl-2xl-4 dds__pl-4xl-4 dds__pl-xl-4 dds__pl-4xl-3">`;

                    if (data.issueWithSupportServicesText !== null) {
                        warratyDetailsText += "";
                    }
                    else if (data.renewOrManageSubscriptionText !== null && data.retailAssetInfo.retailRegisterLinkText === null) {
                        warratyDetailsText += `<a class="dds__link--standalone extendUpgradePlan" data-sub="${data.isSubscriptionEnabled}" href="${data.renewOrManageSubscriptionLink}" target="_blank">${data.renewOrManageSubscriptionText}</a>`;
                    }
                    else if (data.renewOrManageSubscriptionText === null && data.retailAssetInfo !== null && data.retailAssetInfo.retailRegisterLinkText !== null) {
                        warratyDetailsText += `<a class="dds__link--standalone" id="lnkRetailRegister" href="${data.retailAssetInfo.retailRegisterLink}" target="_blank">${data.retailAssetInfo.retailRegisterLinkText}</a>`;
                    }
                    else if (data.renewOrManageSubscriptionText !== null && data.retailAssetInfo !== null && data.retailAssetInfo.retailRegisterLinkText !== null) {
                        warratyDetailsText += `<a class="dds__link--standalone" id="lnkRetailRegister" href="${data.retailAssetInfo.retailRegisterLink}" target="_blank">${data.retailAssetInfo.retailRegisterLinkText}</a>
                                        <span class="mr-0 d-none d-lg-inline text-dark dds__px-2 dds__d-none dds__d-lg-block">|</span>
                                       <a class="dds__link--standalone extendUpgradePlan" data-sub="${data.isSubscriptionEnabled}"  href="${data.renewOrManageSubscriptionLink}" target="_blank">${data.renewOrManageSubscriptionText}</a>`;
                    }
                    warratyDetailsText += "</div>";

                    document.getElementById("subscriptiondetails").innerHTML = warratyDetailsText;

                    if (data.propC57 !== null && data.propC57.trim() !== '') {
                        if (typeof (Dell) !== "undefined") {
                            Dell.Metrics.sc.warranty = data.propC57;
                        }
                        dellMetricsTrackProp20("222.400.100.101", `${appName}|${serviceTag}|${data.propC57}|`);
                    }

                    findDriversButton.addEventListener("click", function (event) {
                        dellMetricsTrackProp20('222.900.200.162', 'home|finddrivers');
                    });
                    if (data.viewDetailsText !== null && data.viewDetailsText !== undefined) {
                        reviewServicesButton.children[0].innerHTML = data.viewDetailsText;
                        reviewServicesButton.addEventListener("click",
                            function (event) {
                                event.preventDefault();
                                dellMetricsTrackProp20('222.900.200.162', 'home|manageservices');
                                window.fetch(`${warrantyModalUrl}&assetId=${assetId}&af=servicetag&loadddsscripts=false`)
                                    .then(response => response.text())
                                    .then(data => {
                                        const ele = document.getElementById("productInfoModal");
                                        ele.innerHTML = "";
                                        SetInnerHtml(ele, data);
                                    }).catch((ex) => {
                                        console.error(`Warranty Modal Api ${ex}`);
                                    });

                                const reviewBtnEvent = new CustomEvent("esupport-detectpcwarranty-review-click",  // TO Do: not required
                                    {
                                        "detail": {
                                            "data": {
                                                serviceTag,
                                                event,
                                                isIssueWithAsset,
                                                warrantyEndDate,
                                                subscriptionEnabled,
                                                warrantyDisplayName,
                                                extendUpgrade,
                                                isUnRegisteredRetailAsset,
                                                isRetailRegistrationPending,
                                                renewOrManageSubscriptionLink,
                                                assetId,
                                                daysRemaining,
                                                isEOSLReached,
                                                assetFormatVal,
                                                isHesAsset,
                                                isSingleSerializedAsset
                                            }
                                        }
                                    });
                                window.dispatchEvent(reviewBtnEvent);
                            });
                        const onLoadBtnEvent = new CustomEvent("esupport-detectpcwarranty-review-onload", // TO Do: not required
                            {
                                "detail": {
                                    "data": {
                                        serviceTag,
                                        isIssueWithAsset,
                                        warrantyEndDate,
                                        subscriptionEnabled,
                                        warrantyDisplayName,
                                        extendUpgrade,
                                        isUnRegisteredRetailAsset,
                                        isRetailRegistrationPending,
                                        renewOrManageSubscriptionLink,
                                        assetId,
                                        daysRemaining,
                                        isEOSLReached,
                                        assetFormatVal,
                                        isHesAsset,
                                        isSingleSerializedAsset
                                    }
                                }
                            });
                        window.dispatchEvent(onLoadBtnEvent);

                    } else if (data.contactTechnicalSupportText) {
                        reviewServicesButton.children[0].innerHTML = data.contactTechnicalSupportText;
                        reviewServicesButton.setAttribute("href", data.contactTechnicalSupportLink);
                        reviewServicesButton.addEventListener("click", function (event) {
                            dellMetricsTrackProp20('222.900.200.162', 'ifd:home|contacttechnicalsupport');
                        });
                    }
                    document.getElementById("divProductInfoLoader")?.classList.add("dds__d-none");
                    document.getElementById("divWarrantyInfo")?.classList.remove("dds__d-none");
                    document.getElementById("divProductInfo")?.classList.remove("dds__d-none");
                })
                .catch((ex) => {
                    document.getElementById("subscriptiondetails").innerHTML = `<div class="dds__row dds__flex-md-column dds__flex-column dds__flex-lg-row dds__justify-content-center dds__justify-content-lg-start">
                                                <div class="dds__d-flex dds__justify-content-center dds__justify-content-lg-start"><i class="dds__icon dds__icon--help-cir dds__mr-1 dds__ml-2 dds__mt-1"></i>We were unable to load your support services status. Please try again later.</div></div>`;
                    document.getElementById("divProductInfoLoader")?.classList.add("dds__d-none");
                    document.getElementById("divWarrantyInfo")?.classList.remove("dds__d-none");
                    console.error(`support service api ${ex}`);
                });
        })
        .catch((ex) => {
            document.getElementById("subscriptiondetails").innerHTML = `<div class="dds__row dds__flex-md-column dds__flex-column dds__flex-lg-row dds__justify-content-center dds__justify-content-lg-start">
                                                <div class="dds__d-flex dds__justify-content-center dds__justify-content-lg-start"><i class="dds__icon dds__icon--help-cir dds__mr-1 dds__ml-2 dds__mt-1"></i>We were unable to load your support services status. Please try again later.</div></div>`;
            document.getElementById("divProductInfoLoader")?.classList.add("dds__d-none");
            document.getElementById("divWarrantyInfo")?.classList.remove("dds__d-none");
            console.error(`support service encrypt api ${ex}`);
        });
}